module.exports = __webpack_public_path__ + "img/quicklink-tiles-chevy.4d93bf92.png";